// import myApi from '@/gavnoCode/ApiHandler';
/*todo загружать данные по партнерам и тд из бд*/
/*
* @param
* skipPartners - [] список партнеров у которых не нужно подтверждать телефон.
* */
const getRandomInt = (max)  => {
  return Math.floor(Math.random() * Math.floor(max));
};

const state = {
  cookie: {
    Partner_Id: null,
    subid: null,
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    utm_content: null,
    utm_term: null,
  },
  skipPartners: [ //игнор проверки телефона
    '100001',
    '100002',
    '100003',
    '100006',
    '100007',
    '100008',
    '100009',
    '100010',
    '100017',
    '100019',
    '100020',
    '100021',
    '100022',
    '100023',
    '100024',
    '100025',
    '100026',
    '100027',
    '100035',
    '100040',

    '405',
  ],
  blockRedirectPartners: [//не уводим отказную заявку в другие лендинги
    '404',
    '405',
    '100006',
    '100041',
    // '100019',
    // '100001',
    // '100002',
    // '100003',
    // '100007',
    // '100008',
    // '100017',
    // '100021',
    // '100010',
  ],
  noRejectRequest:[//не проверяем на ошибки и дубли заявки, обязательно добавить в blockRedirectPartners
    // '405',
    // '100001',
    // '100002',
    // '100003',
    // '100007',
    // '100008',
  ],
  cc:[//только форма не чего лишнего
    '100006',
    '100017',
    '100019',
    '405',
    '100021',
  ],
  ResidentalAdressOnFrstStep:[
    '100006',
  ],
  // partnerLink:['https://t.z24.tech/click?pid=263&offer_id=108','http://manyvkarmany.ru/'],
  // partnerLink:['https://t.leads.tech/client-click/?redirectUrl=https://zaimy-free.ru&sub1='],
  partnerLink:['https://t.leads.tech/client-click/?redirectUrl=https://t.leads.tech/wesite/zaimy-free.ru&sub1='],
  pdl:['100049','100061','100062','100071'],
};

const getters = {
  isConfirmPhone: () => {
    let result = true;
    state.skipPartners.forEach((item)=>{
      if (item == state.cookie.Partner_Id) {
        result = false;
      }
    });
    return result;
  },
  canPdl: () => {
    return state.pdl.includes(state.cookie.Partner_Id);
  },
  isNotCC: () => {
    return !state.cc.includes(state.cookie.Partner_Id);
  },
  doesNotRedirect: () => {
    return state.blockRedirectPartners.includes(state.cookie.Partner_Id);
  },
  doesNotRejectRequest: () => {
    return state.noRejectRequest.includes(state.cookie.Partner_Id);
  },
  getRedirectUrl: () =>{
    if (state.cookie.Partner_Id === undefined) {return false;}
    switch (state.cookie.Partner_Id) {
      // case '100006':
      //   return 'http://manyvkarmany.ru/';
      // case '100003':
      //   return 'https://zaem-store.ru/';
      case '100003':
        return 'https://zaym-dam.ru/';
      case '100002':
        return 'http://manyvkarmany.ru/';
      case '100079':
        return 'http://manyvkarmany.ru/';
      case '100040':
        return 'https://vozmycredit.com/comebacker/finmall/';
      default:
        return state.partnerLink[getRandomInt(1)] + state.cookie.Partner_Id;
    }
  },
  showResidentalAdressOnFrstStep:()=>{
    return state.ResidentalAdressOnFrstStep.includes(state.cookie.Partner_Id);
  }
};

const actions = {
  readCookie: ({commit}) => {
    let cookieArrStp = document.cookie.split(';');
    cookieArrStp.forEach((item) => {
      let tmp = item.split('=');
      if (tmp[0].trim() in state.cookie) {
        if( tmp[0].trim() == 'Partner_Id' ) {
          commit('saveCookie', {
            target: tmp[0].trim(),
            value: tmp[1].trim().toString(),
          });
		} else {
          commit('saveCookie', {
            target: tmp[0].trim(),
            value: tmp[1].trim(),
          });
        }
      }
    });
	//commit('saveCookie', { target: 'Partner_Id', value: '100079', });
  },
};

const mutations = {
  saveCookie: (state, valueObj) => {
    state.cookie[valueObj.target] = valueObj.value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
}
